import { __exports as t } from "./index.es71.js";
var n;
function s() {
  if (n) return t;
  n = 1;
  var a = t.getChildren = function(r) {
    return r.children;
  }, i = t.getParent = function(r) {
    return r.parent;
  };
  return t.getSiblings = function(r) {
    var e = i(r);
    return e ? a(e) : [r];
  }, t.getAttributeValue = function(r, e) {
    return r.attribs && r.attribs[e];
  }, t.hasAttrib = function(r, e) {
    return !!r.attribs && hasOwnProperty.call(r.attribs, e);
  }, t.getName = function(r) {
    return r.name;
  }, t;
}
export {
  s as __require
};
//# sourceMappingURL=index.es51.js.map
